<script lang="ts">
    import { onMount } from "svelte"

    let {
        src,
        type = "application/x-mpegURL",
        poster = null,
        preload = "auto",
        controls = true,
        width = null,
        height = null,
        slot = null,
        fluid = false,
        autoplay = false,
        loop = false,
        muted = true,
        enableAutoplayOnVisible = true,
        controlPlayFromOutside = false,
        play = $bindable(true),
    } = $props()

    let videoE: HTMLVideoElement
    let observer: IntersectionObserver

    if (typeof window !== "undefined" && !src.includes("www.youtube.com")) {
        onMount(() => {
            // @ts-ignore
            import("video.js/dist/video.es").then((m) => {
                const videojs = m.default
                videojs(videoE, {}, function () {})
            })

            if (enableAutoplayOnVisible) {
                observer = new IntersectionObserver(handleIntersect, {
                    threshold: [0.4, 0.6],
                })
                if (videoE) observer.observe(videoE)
            }

            return () => observer?.disconnect()
        })
    }

    if (src?.endsWith(".mp4")) {
        type = "video/mp4"
    } else if (src?.endsWith(".webm")) {
        type = "video/webm"
    } else if (src?.endsWith(".ogv")) {
        type = "video/ogg"
    } else if (src?.endsWith(".m3u8")) {
        type = "application/x-mpegURL"
    }

    function handleIntersect(entries: IntersectionObserverEntry[]) {
        entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                if (videoE.readyState >= 3) {
                    videoE.play().catch((error) => {
                        console.error("Autoplay failed:", error)
                    })
                } else {
                    videoE.addEventListener(
                        "canplay",
                        () => {
                            videoE.play().catch((error) => {
                                console.error("Autoplay on canplay failed:", error)
                            })
                        },
                        { once: true }
                    )
                }
                if (document.fullscreenElement) {
                    document.exitFullscreen().catch((error) => {
                        console.warn("Failed to exit fullscreen:", error)
                    })
                }
            } else {
                videoE.pause()
                videoE.currentTime = 0
            }
        })
    }
    $effect(() => {
        if (controlPlayFromOutside) {
            if (iframe) {
            } else {
                if (play) videoE.play()
                else videoE.pause()
            }
        }
    })
    let iframe: HTMLIFrameElement | null = $state()
</script>

{#if src.includes("www.youtube.com")}
    <div class="video-container">
        <iframe {src} allow="encrypted-media" allowfullscreen bind:this={iframe}></iframe>
    </div>
{:else}
    <video
        bind:this={videoE}
        class="video-js vjs-16-9"
        data-setup={JSON.stringify({ fluid: !!fluid })}
        {controls}
        {poster}
        preload={preload as any}
        {width}
        {height}
        {autoplay}
        playsinline
        webkit-playsinline
        {loop}
        {muted}
        onclick={(e) => {
            e.preventDefault()
        }}
    >
        <source {src} {type} />
        {slot}
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank" rel="noreferrer">supports HTML5 video</a>
        </p>
    </video>
{/if}

<style global lang="less">
    @import "video.js/dist/video-js.css";
    video {
        pointer-events: none;
        background: var(--bg-100);
    }
    .vjs-big-play-button {
        display: none !important;
    }
    .video-container {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;

        .thumbnail,
        iframe {
            position: absolute;
            top: 0;
            bottom: 0px;
            right: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
            cursor: pointer;
        }
    }
</style>
